import React, { useState } from 'react'
import { Button, Input, Label, Row } from 'reactstrap'
import QRGenerator from './Qrgenerator'

export default function GeneradorQR() {
    const [texto, setTexto] = useState("Generar QR");
    const [textoQR, setTextoQR] = useState("");


    return (
        <>
            <Row>
                {textoQR !== "" && (
                    <div className=' col-lg-12 col-md-12 col-sm-12 col-xs-12  mt-3 mb-3'>
                        <QRGenerator data={textoQR} />
                    </div>
                )}

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 "  >
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 floatcenterimp  "   >
                        <Label className={"floatleft"}>Texto a generar </Label>
                        <Input name="texto"
                            onChange={(e) => setTexto(e.target.value)}
                        />
                    </div>
                </div>
                <div className=' col-lg-6 col-md-6 col-sm-6 col-xs-12  mt-3 mb-3'>
                    <Button color="primary" onClick={() => setTextoQR(texto)}>Aceptar</Button>{' '}
                    <Button color="danger" onClick={() => setTextoQR("")}>Limpiar</Button>
                </div>
            </Row>
        </>
    )
};


